import{Button as Lt,InlineMessage as wt,Input as At,Row as St}from"@appcues/sonar";import{useForm as Tt}from"react-hook-form";import{Button as ht,Form as kt,InlineMessage as bt,Input as It}from"@appcues/sonar";import Nt,{css as xt}from"styled-components";var yt=xt`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`,Be=Nt(kt)`
  padding: var(--spacing-regular);
  padding-bottom: 0;

  ${ht} {
    flex: 1;
  }

  ${It} {
    flex: 2;
    ${yt};
  }

  ${bt} {
    padding-top: var(--spacing-small);
  }
`;import{jsx as ue,jsxs as Fe}from"react/jsx-runtime";var D=({user:e,isSpoofing:t,onSpoof:i})=>{let{register:n,handleSubmit:r,formState:{errors:s,isSubmitting:a},setError:c}=Tt(),{isAdmin:m}=e!=null?e:{};return!m||t?null:Fe(Be,{onSubmit:r(async({accountId:p})=>{try{await i(p)}catch(h){c("accountId",{message:"Failed to spoof"})}}),children:[Fe(St,{xAlign:"center",spacing:"small",children:[ue(At,{id:"accountId",placeholder:"Account ID",type:"number",...n("accountId",{required:"Can't be empty"})}),ue(Lt,{type:"submit",disabled:a,children:"Spoof"})]}),s.accountId&&ue(wt,{variant:"error",children:s.accountId.message})]})};import We from"styled-components";var De=We.header`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: var(
    ${({$size:e})=>e==="regular"?"--spacing-large":"--spacing-x-large"}
  );
  padding-top: var(
    ${({$size:e})=>e==="regular"?"--spacing-large":"--spacing-x-large"}
  );
`,$e=We.span`
  align-items: center;
  color: var(--color-blurple-600);
  display: flex;
  font-size: var(--icon-size-large);
  justify-content: center;

  svg {
    height: 30px;
    width: 24px;

    path {
      fill: currentColor;
    }
  }
`;import{jsx as $}from"react/jsx-runtime";var O=({size:e="regular"})=>$(De,{$size:e,children:$("a",{href:"/",children:$($e,{children:$("svg",{viewBox:"0 0 1600 2000",xmlns:"http://www.w3.org/2000/svg",role:"img","aria-label":"Appcues logo",children:$("path",{d:"M695.6 1083.4l555.9 870.5c14.1 21.2 35.3 31 60.7 31h206c39.5 0 70.5-31 70.5-70.5V70.4c0-66.3-83.2-95.9-127-43.7L695.6 998.8c-16.9 22.6-16.9 57.8 0 84.6zM70.6 1985h366.8c39.5 0 70.5-31 70.5-70.5V1446c0-66.3-83.2-95.9-127-43.7L14.1 1870.7c-35.2 48 0 114.3 56.5 114.3z"})})})})});import H from"styled-components";import{Stack as Pt}from"@appcues/sonar";var Oe=H(Pt).attrs({spacing:"none"})`
  position: fixed;
  bottom: 0;
  left: 0;
  top: 0;
  width: 240px;
  background-color: var(--color-neutral-0);
  border-right: 1px solid var(--border-default);
  display: flex;
  flex-direction: column;
  /*
  * This z-index is chosen because it is bigger than the biggest z-index currently
  * found in studio excluding Modals, which is in the studio classic TabsRoot
  * component (z-index: 3000). We will look at standardizing our use of z-index in
  * studio in the future.
  */
  z-index: 4000;
`,He=H.div`
  overflow-y: auto;
  flex-grow: 1;
`,ze=H.nav`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`,Ue=H.ul`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);
  padding-bottom: var(--spacing-small);
  padding-top: var(--spacing-small);
  list-style-type: none;
`,X=H.div`
  width: 18px;
  height: 14px;
`;import{Icon as Ct,Row as Mt,Text as Rt}from"@appcues/sonar";import Ge from"styled-components";import{Text as _e}from"@appcues/sonar";var Y=Ge.li`
  a {
    height: 40px;
    display: flex;
    text-decoration: none;
    padding-left: var(--spacing-large);
    transition: background-color 0.3s ease;

    svg {
      display: block;
      // We use 18px because the banners icon requires a width of 18px
      width: 18px;

      path {
        transition: fill 0.3s ease;
      }
    }
    &.active {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      ${_e} {
        font-weight: var(--font-weight-bold);
      }

      svg path {
        fill: var(--color-blurple-600);
      }
    }

    :hover {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      svg path {
        fill: var(--color-blurple-600);
      }
    }
  }
`,Ve=Ge.button.attrs({type:"button"})`
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: var(--spacing-large);
  padding-right: var(--spacing-regular);
  transition: background-color 0.3s ease;
  border-color: transparent;
  background-color: transparent;
  width: 100%;

  svg {
    display: block;
    // We use 18px because the banners icon requires a width of 18px
    width: 18px;

    path {
      transition: fill 0.3s ease;
    }
  }
  &.active {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${_e} {
      font-weight: var(--font-weight-bold);
    }

    svg path {
      fill: var(--color-blurple-600);
    }
  }

  :hover {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    svg path {
      fill: var(--color-blurple-600);
    }
  }
`;import{jsx as J,jsxs as Et}from"react/jsx-runtime";var Ke=({children:e,icon:t,iconElement:i,NavLink:n,to:r,end:s,isActive:a,className:c,external:m=!1,isSubItem:d=!1,...p})=>J(Y,{className:c,children:J(m||!n?"a":n,{isSubItem:d,to:r,end:s,className:a?"active":"",...p,children:Et(Mt,{spacing:"small",yAlign:"center",children:[i&&i,t&&J(Ct,{icon:t,colorToken:"foreground-secondary",size:"small"}),J(Rt,{colorToken:"foreground-primary",children:e})]})})});import{useState as $t}from"react";import{Accordion as Ot,Row as Ht}from"@appcues/sonar";import{Accordion as Q,Icon as Dt}from"@appcues/sonar";import z,{css as Ze}from"styled-components";import fe,{css as Bt}from"styled-components";import{Row as Ft,Text as qe}from"@appcues/sonar";var Wt=Bt`
  padding: 0 var(--spacing-regular);
`,Z=fe.div`
  a {
    height: ${({variant:e="regular"})=>e==="regular"?"40px":"64px"};
    display: flex;
    text-decoration: none;
    padding: 0 var(--spacing-large);
    ${({isSubItem:e})=>e&&Wt}
    transition: background-color 0.3s ease;

    svg {
      display: block;
      // We use 18px because the banners icon requires a width of 18px
      width: 18px;

      path {
        transition: fill 0.3s ease;
      }
    }

    &.active {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      ${qe} {
        font-weight: var(--font-weight-bold);
      }

      svg path {
        fill: var(--color-blurple-600);
      }
    }

    :hover {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      svg path {
        fill: var(--color-blurple-600);
      }
    }
  }
`,Xe=fe(Ft)`
  max-width: 100%;
`,Ye=fe(qe).attrs({forwardedAs:"span"})`
  flex: 1;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;var ve=Ze`
  fill: var(--color-blurple-600);
`,he=z(Dt)`
  display: block;
  // 18px is used so that the accordion icon aligns with the other nav item icons
  width: 18px;

  path {
    transition: fill 0.3s ease;
    // The active state is determined programatically because when the accordion is closed the active list item is reomved from the DOM
    ${({$isActive:e})=>e&&ve}
  }
`,Je=Ze`
  background-color: var(--color-neutral-50);
  border-radius: var(--border-radius-small);
`,Qe=z(Q.Header)`
  height: 40px;
  display: flex;
  // The Sonar Accordion.Header has some padding that we need to override so that the correct hover background can be applied
  padding: 0;
  font-weight: var(--font-weight-regular);
  transition: background-color 0.3s ease;

  :hover {
    ${Je};

    ${he} {
      path {
        ${ve};
      }
    }
  }

  /* Shows accordion header as active if collapsed */
  &[data-state='closed'] {
    ${({$isActive:e})=>e&&Je};
  }
`,je=z(Q.Trigger)`
  color: var(--foreground-primary);
  padding-left: var(--spacing-large);
  padding-right: var(--spacing-regular);
`,eo=z(Q.Content)`
  p {
    // Padding of 26px is required so that the accordion content aligns correctly with the other nav item text
    padding-left: 26px;
  }

  // We don't want padding on the last list item because a 4px space is already provided by the flex gap
  li {
    &:not(:last-child) {
      padding-bottom: var(--spacing-x-small);
    }
  }
`,oo=z(Q.Item)`
  // These styles create a gap between the trigger and the content when the accordion is expanded, but
  // the gap is removed when the accordion is collapsed
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);

  // This selector is used to apply the blurple fill to the accordion icon when one of it's children is hovered
  &:has(div > li > a:hover) {
    div > svg > path {
      ${ve}
    }
  }

  ${Z} {
    margin-left: var(--spacing-x-large);
    margin-right: var(--spacing-small);
    position: relative;
    &::before {
      content: '';
      display: block;
      width: 1px;
      height: 100%;
      background-color: var(--color-neutral-300);
      position: absolute;
      left: 0;
      top: 0;
    }
  }
`;import{jsx as U,jsxs as no}from"react/jsx-runtime";var zt="@navigation/accordion_",to={getAccordionKey(e){return`${zt}${e}`},getAccordionValue(e){let t=this.getAccordionKey(e);return localStorage.getItem(t)},setAccordionValue(e,t){let i=this.getAccordionKey(e);Boolean(t)?localStorage.setItem(i,t):localStorage.removeItem(i)}},io=({children:e,text:t,icon:i,isActive:n})=>{let r=()=>{if(n)return t;let m=to.getAccordionValue(t);if(m)return m},[s,a]=$t(r()),c=m=>{a(m),to.setAccordionValue(t,m)};return U(Ot.Root,{collapsible:!0,value:s,onValueChange:c,type:"single",$unstyled:!0,children:no(oo,{value:t,children:[U(Qe,{$isActive:n,children:U(je,{children:no(Ht,{spacing:"small",yAlign:"center",children:[U(he,{icon:i,colorToken:"color-neutral-700",size:"small",$isActive:n}),t]})})}),U(eo,{children:e})]})})};import{jsx as ao}from"react/jsx-runtime";var ro=({children:e,isActive:t,onClick:i})=>ao(Y,{children:ao(Ve,{onClick:i,className:t?"active":"",children:e})});import{Icon as so,Row as lo,Text as Ut}from"@appcues/sonar";import{faChevronRight as Gt}from"@fortawesome/pro-solid-svg-icons/faChevronRight";import{jsx as j,jsxs as po}from"react/jsx-runtime";var co=({icon:e,label:t})=>po(lo,{xAlign:"space-between",yAlign:"center",children:[po(lo,{spacing:"small",yAlign:"center",children:[j(X,{children:j(so,{icon:e,colorToken:"foreground-secondary",size:"small"})}),j(Ut,{colorToken:"foreground-primary",forwardedAs:"span",children:t})]}),j(so,{icon:Gt,colorToken:"foreground-secondary",size:"small"})]});import{forwardRef as _t}from"react";import{Icon as Vt,NavigationMenu as Kt}from"@appcues/sonar";import{jsx as R,jsxs as qt}from"react/jsx-runtime";var mo=_t(({children:e,icon:t,iconElement:i,NavLink:n,to:r,end:s,isActive:a,external:c=!1,isSubItem:m,variant:d="regular",title:p,...h},v)=>{let k=c||!n?"a":n;return R(Z,{isSubItem:m,variant:d,className:"accordion-link-item",children:R(Kt.Link,{asChild:!0,children:R(k,{ref:v,to:r,end:s,className:a?"active":"",...h,children:qt(Xe,{fluid:!0,spacing:"small",yAlign:"center",children:[i&&i,t&&R(X,{children:R(Vt,{icon:t,colorToken:"foreground-secondary",size:"small"})}),R(Ye,{colorToken:"foreground-primary",title:p||"",children:e})]})})})})});import{NavigationMenu as Jt}from"@appcues/sonar";import Xt from"styled-components";import{Text as Yt}from"@appcues/sonar";var go=Xt.button.attrs({type:"button"})`
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 var(--spacing-regular);
  transition: background-color 0.3s ease;
  border-color: transparent;
  background-color: transparent;
  width: 100%;
  border: 0;

  svg {
    display: block;
    // We use 18px because the banners icon requires a width of 18px
    width: 18px;

    path {
      transition: fill 0.3s ease;
    }
  }
  &.active {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${Yt} {
      font-weight: var(--font-weight-bold);
    }

    svg path {
      fill: var(--color-blurple-600);
    }
  }

  :hover {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    svg path {
      fill: var(--color-blurple-600);
    }
  }
`;import{jsx as uo}from"react/jsx-runtime";var fo=({children:e,onClick:t,className:i})=>uo(Jt.Link,{asChild:!0,children:uo(go,{onClick:t,className:i,children:e})});var o={Wrapper:Oe,ScrollContainer:He,NavList:Ue,Nav:ze,NavItem:Ke,NavButton:ro,NavAccordion:io,NavTrigger:co,LinkItem:mo,ButtonItem:fo};import{useEffect as ke}from"react";function vo({user:e,account:t,cannyAppId:i,isOpen:n}){ke(()=>{if(window.Canny&&t&&e){let{id:r,isTrial:s,tier:a,stripePlanId:c}=t,{fullname:m,email:d,id:p,job:h,crxVersion:v}=e;window.Canny("identify",{appID:i,user:{email:d,name:m||"anonymous",id:p,customFields:{job:h,crxVersion:v},companies:[{customFields:{isTrial:s,tier:a,stripePlanId:c},id:r,name:r}]}})}},[t,i,e]),ke(()=>{!n&&window.Canny&&window.Canny("closeChangelog")},[n]),ke(()=>{new MutationObserver(()=>{if(document.querySelector("[data-canny-changelog]"))try{window.Canny("initChangelog",{appID:i,position:"right",align:"bottom"})}catch(a){}}).observe(document.body,{childList:!0,subtree:!0})},[i])}import{Icon as rn,Row as sn,Tooltip as ln}from"@appcues/sonar";import{faScrewdriverWrench as pn}from"@fortawesome/pro-solid-svg-icons/faScrewdriverWrench";import _ from"styled-components";import{Button as nn,Stack as an,NavigationMenu as yo}from"@appcues/sonar";import{Progress as on}from"@appcues/sonar";import tn from"pluralize";import{differenceInDays as Zt}from"date-fns";var be=(e,t)=>Zt(e,t),ho=e=>new Intl.DateTimeFormat(void 0,{year:"numeric",month:"short",day:"2-digit"}).format(e);var Ie=(e,t)=>!((e==null?void 0:e.stripePlanId)||(t==null?void 0:t.isExpired));import G from"styled-components";import{Skeleton as Qt}from"@studio/legacy-components";import{Button as jt,Tooltip as en}from"@appcues/sonar";var ko=G.div`
  text-align: center;
  gap: 8px;
  padding: 16px 24px 0 24px;
  display: flex;
  flex-direction: column;

  ${Qt} {
    width: 140px;
    height: 40px;
    margin: 0 auto;
  }

  ${jt} {
    --link-color: #ffffff;
    --link-text-decoration: none;
    --link-visited-color: #ffffff;
  }
`,bo=G.div`
  font-weight: 700;
  color: rgb(57, 68, 85);
  font-size: 14px;
`,Io=G.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  width: 100%;
`,No=G.div`
  width: 180px;
  white-space: pre-wrap;
  font-size: 0.75rem;
`,xo=G(en)`
  width: 100%;
`;import{jsx as ee,jsxs as Ne}from"react/jsx-runtime";var xe=({account:e={},trialStatus:t={},className:i,Link:n})=>{let{createdAt:r,expirationDate:s,isWebInstalled:a,lengthDays:c}=t;if(!Ie(e,t)||!r||!s)return null;let d=be(new Date(s),new Date(r))+1,p=be(new Date(s),new Date)+1,v=(d-p)/d,k=Math.round(v*100),x=p>7?"default":(p>3,"error"),L=Ne(No,{children:["Trial expires on ",ho(new Date(s)),"."," ",a?"":`Install the Appcues SDK to extend your trial another ${c} days.`]});return Ne(ko,{className:i,children:[ee(xo,{placement:"right",content:L,children:Ne(Io,{children:[ee(bo,{children:`${p} ${tn("day",p)} left in trial`}),ee(on,{value:k,max:100,variant:x})]})}),ee(n,{to:"/subscription",children:"Upgrade now"})]})};var oe=_(yo.Trigger)`
  height: 40px;
`,Lo=_(an).attrs({spacing:"large"})`
  padding: var(--spacing-large);
`,wo=_(xe)`
  padding: 0;
`,ye=_(nn)`
  width: 100%;
  text-decoration: none;
`,E=_(yo.Content)`
  position: absolute;
  transform: translateY(-40px);
  left: 100%;
  margin-left: var(--spacing-x-small);
  background-color: var(--color-neutral-0);
  border-radius: var(--border-radius-small);
  gap: var(--spacing-x-small);
  padding: var(--spacing-small) var(--spacing-x-small);
  box-shadow: var(--elevation-300);
  transform: translateY(-40px);
  width: 200px;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
`;import{jsx as V,jsxs as Ao}from"react/jsx-runtime";var So=({NavLink:e,isInstalled:t,account:i,trialStatus:n})=>Ao(Lo,{children:[t?null:V(ln,{size:"regular",content:"In order to publish live experiences to your users, you'll have to install Appcues directly into your codebase. Don't worry...it's super easy. Click here to learn how!",children:V(ye,{variant:"secondary",fluid:!0,forwardedAs:e,to:"/settings/installation",children:Ao(sn,{spacing:"small",yAlign:"center",children:[V(rn,{icon:pn}),"Install"]})})}),V(wo,{account:i,trialStatus:n,Link:r=>V(ye,{variant:"tertiary",forwardedAs:e,...r})})]});import{useState as Bo}from"react";import{faGear as dn}from"@fortawesome/pro-solid-svg-icons/faGear";import{faChevronRight as un}from"@fortawesome/pro-solid-svg-icons/faChevronRight";import{faExternalLink as fn}from"@fortawesome/pro-solid-svg-icons/faExternalLink";import{faArrowRightFromBracket as vn}from"@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket";import{Icon as ne,Row as we,Stack as hn,Text as Ae,NavigationMenu as ie}from"@appcues/sonar";import S from"styled-components";import{Text as To,Stack as cn,Row as mn}from"@appcues/sonar";import{Separator as gn}from"@radix-ui/react-separator";var Po=S(cn).attrs({spacing:"x-small"})`
  padding-top: var(--spacing-regular);
  padding-bottom: var(--spacing-regular);
`,Co=S(E)`
  transform: translateY(-105%);
  width: 237px;
`,Mo=S(mn)`
  max-width: calc(100% - var(--spacing-large));
`,te=S(To).attrs({colorToken:"foreground-primary",forwardedAs:"span",weight:"bold"})`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`,Ro=S.div`
  display: flex;
  padding: var(--spacing-small) var(--spacing-regular);
  cursor: pointer;
`,Eo=S(To)`
  padding-left: 22px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`,Le=S(gn)`
  height: 1px;
  background: var(--border-default);
  margin: 0px var(--spacing-regular);
`;import{jsx as f,jsxs as A}from"react/jsx-runtime";var Fo=({NavLink:e,onLogout:t,user:{email:i,fullName:n}={},companyName:r,accountsCount:s})=>{let a=r||i||"",[c,m]=Bo(),[d,p]=Bo(!1),h=v=>{c&&!d&&(v.preventDefault(),p(!0)),c&&d&&p(!1)};return f(ie.Root,{orientation:"vertical",value:c,onValueChange:v=>{m(v),v||p(!1)},children:f(ie.List,{children:A(ie.Item,{value:"account-menu",children:[f(ie.Trigger,{onClick:h,children:A(Po,{children:[A(we,{xAlign:"space-between",yAlign:"center",children:[A(Mo,{spacing:"small",yAlign:"center",children:[f(ne,{icon:dn,colorToken:"foreground-secondary",size:"small"}),f(te,{title:a,children:a})]}),f(ne,{icon:un,colorToken:"foreground-secondary",size:"small"})]}),n&&f(Eo,{title:n,size:"small",children:n})]})}),f(Co,{children:A("ul",{children:[s>1?f(o.LinkItem,{isSubItem:!0,variant:"tall",NavLink:e,to:"/accounts-v2",children:A(hn,{spacing:"x-small",children:[f(te,{title:a,children:a}),f(Ae,{size:"small",children:"Switch Accounts"})]})}):f(Ro,{children:f(te,{title:a,children:a})}),f(Le,{}),f(o.LinkItem,{isSubItem:!0,NavLink:e,to:"/settings/account",children:"Settings"}),f(o.LinkItem,{external:!0,isSubItem:!0,"data-canny-link":!0,href:"https://feedback.appcues.com/product-feedback?sort=top",target:"_blank",children:"Suggest a feature"}),f(o.LinkItem,{external:!0,isSubItem:!0,href:"https://status.appcues.com",target:"_blank",children:A(we,{xAlign:"space-between",yAlign:"center",children:[f(Ae,{forwardedAs:"span",children:"Appcues status"}),f(ne,{icon:fn,colorToken:"foreground-link"})]})}),f(Le,{}),f("li",{children:f(o.ButtonItem,{onClick:t,children:A(we,{fluid:!0,xAlign:"space-between",yAlign:"center",children:[f(Ae,{colorToken:"foreground-primary",forwardedAs:"span",children:"Sign out"}),f(ne,{colorToken:"foreground-secondary",icon:vn})]})})})]})})]})})})};import B from"styled-components";import{NavigationMenu as Wo,Row as kn}from"@appcues/sonar";import{Separator as bn}from"@radix-ui/react-separator";var F=B(bn)`
  height: 1px;
  background: var(--border-default);
  margin: 0px var(--spacing-regular);
  padding: 0.1px 0 0 0;
`,ae=B.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-regular);
  height: 100%;
  overflow-y: auto;
`,Do=B(Wo.Root)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  & ul {
    list-style-type: none;
  }
`,$o=B(Wo.Root)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;

  & ul {
    list-style-type: none;
  }
`,K=B.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);
`,Oo=B(kn).attrs({spacing:"x-small",yAlign:"center",xAlign:"center"})`
  background: var(--color-neutral-100);
  border-radius: var(--border-radius-small);
  padding: var(--spacing-x-small);
  color: var(--foreground-secondary);

  svg path {
    fill: var(--foreground-secondary) !important;
  }
`;import{useState as Ko}from"react";import{NavigationMenu as le}from"@appcues/sonar";import{faFolderMagnifyingGlass as En}from"@fortawesome/pro-regular-svg-icons/faFolderMagnifyingGlass";import{faTableList as Bn}from"@fortawesome/pro-solid-svg-icons/faTableList";import{faFlag as Fn}from"@fortawesome/pro-solid-svg-icons/faFlag";import{faUsers as zo}from"@fortawesome/pro-solid-svg-icons/faUsers";import{faArrowsTurnToDots as In}from"@fortawesome/pro-solid-svg-icons/faArrowsTurnToDots";import{faMessages as Nn}from"@fortawesome/pro-solid-svg-icons/faMessages";import{faMap as Uo}from"@fortawesome/pro-solid-svg-icons/faMap";import{faThumbtack as xn}from"@fortawesome/pro-solid-svg-icons/faThumbtack";import{faCheckCircle as yn}from"@fortawesome/pro-solid-svg-icons/faCheckCircle";import{faComment as Ln}from"@fortawesome/pro-solid-svg-icons/faComment";import{faRocket as wn}from"@fortawesome/pro-solid-svg-icons/faRocket";import{faChartColumn as Go}from"@fortawesome/pro-solid-svg-icons/faChartColumn";import{faBullseye as An}from"@fortawesome/pro-solid-svg-icons/faBullseye";import{faChartPieSimple as Sn}from"@fortawesome/pro-solid-svg-icons/faChartPieSimple";import{faBuildings as Tn}from"@fortawesome/pro-solid-svg-icons/faBuildings";import{faTh as Pn}from"@fortawesome/pro-solid-svg-icons/faTh";import{faRectangleCode as Cn}from"@fortawesome/pro-solid-svg-icons/faRectangleCode";import{NavigationMenu as re}from"@appcues/sonar";import{faEnvelopeOpen as Mn}from"@fortawesome/pro-solid-svg-icons";import{jsx as Ho}from"react/jsx-runtime";var W=()=>Ho("svg",{width:"18",height:"16",viewBox:"0 0 18 16",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:Ho("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M17.1258 5L14.902 8.00085L17.1246 11H1.1258L3.34967 7.99915L1.12706 5H17.1258ZM0.874146 11H0.874181L0.874181 5H0.874146V11Z",fill:"var(--foreground-secondary)"})});import{Fragment as Rn,jsx as u,jsxs as T}from"react/jsx-runtime";var _o={MESSAGING:[/^\/banners(\/.*)?$/,/^\/pins(\/.*)?$/,/^\/checklists(\/.*)?$/,/^\/nps(\/.*)?$/,/^\/nps-v2(\/.*)?$/,/^\/launchpads(\/.*)?$/,/^\/flows-v2(\/.*)?$/,/^\/embeds(\/.*)?$/],METRICS:[/^\/goals(\/.*)?$/,/^\/insights\/explorer(\/.*)?$/,/^\/insights\/charts(\/.*)?$/,/^\/email-performance(\/.*)?$/]},se=(e,t)=>t.some(i=>e.startsWith(i)),Vo=(e,t)=>t.some(i=>i.test(e)),Se=({NavLink:e,currentPath:t,featureFlags:i,handleClick:n})=>{let{hasLaunchpads:r,hasNps2:s,hasOpenBuilderFlows:a}=i,c=se(t,["/flows","/mobile","/experiments"]),m=Vo(t,[..._o.MESSAGING])||c,d=se(t,["/audience/segments","/segments"]),p=se(t,["/audience/users"]),h=se(t,["/audience"])||d||p,v=Vo(t,[..._o.METRICS]);return T(Rn,{children:[u(re.Item,{children:u(o.LinkItem,{icon:In,NavLink:e,to:"/workflows",children:"Workflows"},"/workflows")}),T(re.Item,{value:"messaging-menu",children:[u(oe,{className:m?"active":"",onClick:k=>n(k,"messaging-menu"),children:u(o.NavTrigger,{icon:Nn,label:"Messaging"})}),u(E,{children:T("ul",{children:[u(o.LinkItem,{icon:Uo,NavLink:e,to:"/flows",isSubItem:!0,isActive:c,children:"Flows"},"/flows"),a&&u(o.LinkItem,{icon:Uo,NavLink:e,to:"/flows-v2",isSubItem:!0,children:"Flows 2.0"},"/flows-v2"),u(o.LinkItem,{icon:Cn,NavLink:e,to:"/embeds",isSubItem:!0,children:"Embeds"},"/embeds"),u(o.LinkItem,{iconElement:u(W,{}),NavLink:e,to:"/banners",isSubItem:!0,children:"Banners"},"/banners"),u(o.LinkItem,{icon:xn,NavLink:e,to:"/pins",isSubItem:!0,children:"Pins"},"/pins"),u(o.LinkItem,{icon:yn,NavLink:e,to:"/checklists",isSubItem:!0,children:"Checklists"},"/checklists"),u(o.LinkItem,{icon:Ln,NavLink:e,to:s?"/nps-v2":"/nps",isSubItem:!0,children:"NPS"},"/nps"),r&&u(o.LinkItem,{icon:wn,NavLink:e,to:"/launchpads",isSubItem:!0,children:"Launchpads"},"/launchpads")]})})]}),T(re.Item,{value:"audiences-menu",children:[u(oe,{className:h?"active":"",onClick:k=>n(k,"audiences-menu"),children:u(o.NavTrigger,{icon:zo,label:"Audiences"})}),u(E,{children:T("ul",{children:[u(o.LinkItem,{icon:Sn,NavLink:e,to:"/audience/segments-v2",isSubItem:!0,isActive:d,children:"Segments"},"/audience/segments-v2"),u(o.LinkItem,{icon:zo,NavLink:e,to:"/audience/users-v2",isSubItem:!0,isActive:p,children:"Users"},"/audience/users-v2"),u(o.LinkItem,{icon:Tn,NavLink:e,to:"/audience/accounts",isSubItem:!0,children:"Accounts"},"/audience/accounts")]})})]}),T(re.Item,{value:"metrics-menu",children:[u(oe,{className:v?"active":"",onClick:k=>n(k,"metrics-menu"),children:u(o.NavTrigger,{icon:Go,label:"Metrics"})}),u(E,{children:T("ul",{children:[u(o.LinkItem,{icon:An,NavLink:e,to:"/goals",isSubItem:!0,children:"Goals"},"/goals"),u(o.LinkItem,{icon:Go,NavLink:e,to:"/insights/explorer",isSubItem:!0,children:"Events Explorer"},"/insights/explorer"),u(o.LinkItem,{icon:Pn,NavLink:e,to:"/insights/charts",isSubItem:!0,children:"Saved Charts"},"/insights/charts"),u(o.LinkItem,{icon:Mn,NavLink:e,to:"/email-performance",isSubItem:!0,children:"Email Performance"},"/email-performance")]})})]})]})};import{jsx as y,jsxs as Wn}from"react/jsx-runtime";function Te({hasAiAssistant:e,hasOverviewRedirect:t,isInstalled:i,NavLink:n,matchExactRoutes:r,actions:s,currentPath:a,hasLaunchpads:c,hasNps2:m,hasDevTools:d,hasOpenBuilderFlows:p}){let[h,v]=Ko(),[k,x]=Ko({}),L=(I,b)=>{h===b&&!k[b]&&(I.preventDefault(),x({[b]:!0})),h===b&&k[b]&&x({[b]:!1})},w=(I,b)=>{L(I,b)};return y(Do,{orientation:"vertical",value:h,onValueChange:I=>{v(I),I||x({})},children:y(le.List,{children:Wn(ae,{children:[e&&s?s:null,t&&!i?null:y(le.Item,{children:y(o.LinkItem,{icon:Bn,NavLink:n,to:"/",end:r,children:"Overview"})}),y(K,{children:y(Se,{NavLink:n,currentPath:a,handleClick:(I,b)=>w(I,b),featureFlags:{hasLaunchpads:c,hasNps2:m,hasOpenBuilderFlows:p}})}),y(F,{}),y(le.Item,{children:y(o.LinkItem,{icon:En,NavLink:n,to:"/folders",children:"Folders"})}),d&&y(le.Item,{children:y(o.LinkItem,{icon:Fn,NavLink:n,to:"/dev-tools",children:"Dev Tools"})})]})})})}import{Icon as Dn,NavigationMenu as Pe,Row as $n}from"@appcues/sonar";import{trackEvent as On}from"@studio/analytics";import{faArrowsTurnToDots as Hn,faMessages as zn,faMap as qo,faThumbtack as Un,faCheckCircle as Gn,faComment as _n,faChartColumn as Xo,faBullseye as Vn,faEnvelopeOpen as Kn,faTh as qn,faUsers as Yo,faChartPieSimple as Xn,faBuildings as Yn,faRocket as Jn,faChartLine as Zn,faFlask as Qn,faRectangleCode as jn,faLightbulb as ei,faBarsFilter as oi,faGauge as ti}from"@fortawesome/pro-solid-svg-icons";import{faFolderMagnifyingGlass as ni}from"@fortawesome/pro-regular-svg-icons/faFolderMagnifyingGlass";import{faTableList as ii}from"@fortawesome/pro-solid-svg-icons/faTableList";import{faFlag as ai}from"@fortawesome/pro-solid-svg-icons/faFlag";import{faSparkles as ri}from"@fortawesome/pro-regular-svg-icons";import{jsx as l,jsxs as P}from"react/jsx-runtime";var si=["/flows","/pins","/banners","/checklists","/nps","/embeds"],li=["/flows","/flows-v2"],pi=["/goals","/insights/explorer","/insights/charts","/insights/funnels","/email-performance"],ci=["/audience/segments-v2","/audience/users-v2","/audience/accounts"],pe=(e,t)=>e.some(i=>t.startsWith(i));function Ce({hasAiAssistant:e,hasOverviewRedirect:t,isInstalled:i,NavLink:n,matchExactRoutes:r,actions:s,currentPath:a,hasNps2:c,hasDevTools:m,hasAiInsights:d,hasFunnels:p,hasDashboards:h,hasOpenBuilderFlows:v}){let k=pe(si,a),x=pe(pi,a),L=pe(ci,a),w=pe(li,a);return l($o,{orientation:"vertical",children:l(Pe.List,{children:P(ae,{children:[e&&s?s:null,P(K,{children:[h&&l(o.LinkItem,{icon:ti,NavLink:n,to:"/dashboards",children:"Dashboards"}),t&&!i?null:l(o.LinkItem,{icon:ii,NavLink:n,to:"/",end:r,children:"Overview"}),d&&l(o.LinkItem,{NavLink:n,to:"/insights-feed",icon:ei,onClick:()=>{On({name:"nav_click",properties:{navItemID:"insights-feed",navItemName:"Insights"}})},children:P($n,{xAlign:"space-between",yAlign:"center",spacing:"small",children:["Insights",l(Oo,{children:l(Dn,{icon:ri,size:"small"})})]})})]}),P(K,{children:[P(o.NavAccordion,{isActive:k,text:"Experiences",icon:zn,children:[l(o.LinkItem,{NavLink:n,to:"/flows",icon:qo,isActive:w,isSubItem:!0,children:"Flows"},"/flows"),v&&l(o.LinkItem,{icon:qo,NavLink:n,to:"/flows-v2",isSubItem:!0,title:"Flows 2.0",children:"Flows 2.0"},"/flows-v2"),l(o.LinkItem,{icon:jn,NavLink:n,to:"/embeds",isSubItem:!0,title:"Embeds",children:"Embeds"},"/embeds"),l(o.LinkItem,{NavLink:n,to:"/pins",icon:Un,isSubItem:!0,children:"Pins"},"/pins"),l(o.LinkItem,{NavLink:n,to:"/banners",iconElement:l(W,{}),isSubItem:!0,children:"Banners"},"/banners"),l(o.LinkItem,{NavLink:n,to:"/checklists",icon:Gn,isSubItem:!0,children:"Checklists"},"/checklists"),l(o.LinkItem,{NavLink:n,to:c?"/nps-v2":"/nps",icon:_n,isSubItem:!0,children:"NPS"},"/nps"),l(o.LinkItem,{icon:Jn,NavLink:n,to:"/launchpads",isSubItem:!0,children:"Launchpads"},"/launchpads")]}),P(o.NavAccordion,{isActive:x,text:"Metrics",icon:Xo,children:[l(o.LinkItem,{NavLink:n,to:"/goals",icon:Vn,isSubItem:!0,children:"Goals"},"/goals"),l(o.LinkItem,{icon:Xo,NavLink:n,to:"/insights/explorer",isSubItem:!0,children:"Events Explorer"},"/insights/explorer"),l(o.LinkItem,{icon:qn,NavLink:n,to:"/insights/charts",isSubItem:!0,children:"Saved Charts"},"/insights/charts"),p&&l(o.LinkItem,{icon:oi,NavLink:n,to:"/insights/funnels",isSubItem:!0,children:"Funnels"},"/insights/funnels"),l(o.LinkItem,{NavLink:n,to:"/experiments",icon:Qn,isSubItem:!0,children:"Experiments"},"/experiments"),l(o.LinkItem,{NavLink:n,to:"/performance",icon:Zn,isSubItem:!0,children:"Flow Performance"},"/performance"),l(o.LinkItem,{title:"Email Performance",icon:Kn,NavLink:n,to:"/email-performance",isSubItem:!0,children:"Email Performance"},"/email-performance")]}),P(o.NavAccordion,{isActive:L,text:"Audiences",icon:Yo,children:[l(o.LinkItem,{icon:Xn,NavLink:n,to:"/audience/segments-v2",isSubItem:!0,children:"Segments"},"/audience/segments-v2"),l(o.LinkItem,{icon:Yo,NavLink:n,to:"/audience/users-v2",isSubItem:!0,children:"Users"},"/audience/users-v2"),l(o.LinkItem,{icon:Yn,NavLink:n,to:"/audience/accounts",isSubItem:!0,children:"Accounts"},"/audience/accounts")]}),l(o.LinkItem,{NavLink:n,to:"/workflows",icon:Hn,children:"Workflows"},"/workflows")]}),l(F,{}),l(Pe.Item,{children:l(o.LinkItem,{icon:ni,NavLink:n,to:"/folders",children:"Folders"})}),m&&l(Pe.Item,{children:l(o.LinkItem,{icon:ai,NavLink:n,to:"/dev-tools",children:"Dev Tools"})})]})})})}import{jsx as C,jsxs as mi}from"react/jsx-runtime";var Jo=({user:e,account:t,accountsCount:i,onSpoof:n,onLogout:r,isSpoofing:s,NavLink:a,featureFlags:c,matchExactRoutes:m,isInstalled:d,trialStatus:p,cannyAppId:h,currentPath:v,actions:k})=>{let{hasDevTools:x,hasLaunchpads:L,hasOverviewRedirect:w,hasAiAssistant:I,hasNps2:b,hasNav2025:ge,hasAiInsights:de,hasFunnels:N,hasDashboards:vt,hasOpenBuilderFlows:Ee}=c;return vo({user:e,account:t,cannyAppId:h,isOpen:!1}),mi(o.Wrapper,{children:[C(D,{user:e,onSpoof:n,isSpoofing:s}),C(O,{size:"large"}),ge?C(Ce,{hasDevTools:x,hasOverviewRedirect:w,isInstalled:d,NavLink:a,matchExactRoutes:m,actions:k,currentPath:v,hasNps2:b,hasAiAssistant:I,hasAiInsights:de,hasFunnels:N,hasDashboards:vt,hasOpenBuilderFlows:Ee}):C(Te,{hasDevTools:x,hasLaunchpads:L,hasOverviewRedirect:w,isInstalled:d,NavLink:a,matchExactRoutes:m,actions:k,currentPath:v,hasNps2:b,hasAiAssistant:I,hasOpenBuilderFlows:Ee}),C(So,{NavLink:a,isInstalled:d,account:t,trialStatus:p}),C(F,{}),C(Fo,{user:e,companyName:t==null?void 0:t.name,NavLink:a,accountsCount:i,onLogout:r})]})};import{faCircleUser as Ii}from"@fortawesome/pro-solid-svg-icons/faCircleUser";import{faPeopleGroup as Ni}from"@fortawesome/pro-solid-svg-icons/faPeopleGroup";import{faCreditCard as xi}from"@fortawesome/pro-regular-svg-icons/faCreditCard";import{faLaptopMobile as yi}from"@fortawesome/pro-solid-svg-icons/faLaptopMobile";import{faPaperPlane as Li}from"@fortawesome/pro-solid-svg-icons/faPaperPlane";import{faPlug as wi}from"@fortawesome/pro-solid-svg-icons/faPlug";import{faDatabase as Ai}from"@fortawesome/pro-solid-svg-icons/faDatabase";import{faGlobe as Si}from"@fortawesome/pro-solid-svg-icons/faGlobe";import{faSparkles as Ti}from"@fortawesome/pro-solid-svg-icons/faSparkles";import{faArrowRightFromBracket as Pi}from"@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket";import{faPalette as Ci}from"@fortawesome/pro-solid-svg-icons/faPalette";import{Icon as Mi,NavigationMenu as ot,Row as Ri,Text as Ei}from"@appcues/sonar";import gi from"styled-components";import{Button as di,Icon as ui,Text as fi,Tooltip as vi}from"@appcues/sonar";import{faChevronLeft as hi}from"@fortawesome/pro-solid-svg-icons/faChevronLeft";import{jsx as q}from"react/jsx-runtime";var ki=gi.div`
  justify-self: end;
`,Zo=({onClick:e})=>q(ki,{children:q(vi,{content:q(fi,{size:"small",lineHeight:"large",colorToken:"foreground-tooltip",children:"Exit settings"}),placement:"bottom",children:q(di,{title:"back link",variant:"tertiary",iconOnly:!0,onClick:e,children:q(ui,{icon:hi})})})});import{Text as bi}from"@appcues/sonar";import Me from"styled-components";var Qo=Me(bi)`
  padding-left: var(--spacing-large);
  padding-top: var(--spacing-regular);
  padding-bottom: var(--spacing-regular);
`,jo=Me.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
`,et=Me.div`
  padding-bottom: var(--spacing-small);
`;import{jsx as g,jsxs as M}from"react/jsx-runtime";var Bi=new Set(["/settings/integrations","/webhooks","/settings/keys","/integrations/webhooks","/integrations/connections"]),Fi=new Set(["/settings/events","/settings/properties","/settings/properties/users","/settings/properties/groups"]),Wi=["/settings/themes",/^\/themes(\/.*)?$/],Di=["/settings/installation",/apps\/[^/]+$/],$i=["/settings/emails/senders",/\/settings\/emails\/suppression-lists\/[^/]+$/],tt=({NavLink:e,featureFlags:t,currentPath:i,user:n,onSpoof:r,isSpoofing:s,onClickBackArrow:a,onClickLogout:c,hasLocalizationAccess:m,actions:d})=>{let{hasIntegrationPageRedesign:p,hasMobileFlows:h,hasAIAssistant:v,hasSubscription:k}=t,x=Bi.has(i),L=Wi.some(N=>typeof N=="string"?N===i:N.test(i)),w=Fi.has(i),I=Di.some(N=>typeof N=="string"?N===i:N.test(i)),b=$i.some(N=>typeof N=="string"?N===i:N.test(i)),ge=i.includes("/settings/emails/suppression-lists/"),de=i.startsWith("/settings/properties");return M(o.Wrapper,{children:[g(D,{user:n,onSpoof:r,isSpoofing:s}),M(jo,{children:[g(Zo,{onClick:a}),g(O,{})]}),g(ot.Root,{orientation:"vertical",children:g(ot.List,{children:v&&d?d:null})}),g(Qo,{size:"medium",weight:"semibold",children:"Settings"}),g(o.ScrollContainer,{children:g(o.Nav,{children:M(o.NavList,{children:[g(o.NavItem,{icon:Ii,NavLink:e,to:"/settings/account",children:"Profile"}),g(o.NavItem,{icon:Ni,NavLink:e,to:"/settings/team",children:"Team"}),k&&g(o.NavItem,{icon:xi,NavLink:e,to:"/settings/subscription",children:"Subscription"}),g(o.NavItem,{icon:yi,NavLink:e,to:"/settings/installation",isActive:I,children:h?"Apps & Installation":"Installation"}),g(o.NavItem,{icon:Ci,NavLink:e,to:"/settings/themes",isActive:L,children:"Themes"}),v&&g(o.NavItem,{icon:Ti,NavLink:e,to:"/settings/ai-assistant",children:"Appcues AI"}),M(o.NavAccordion,{text:"Emails",icon:Li,isActive:b,children:[g(o.NavItem,{NavLink:e,to:"/settings/emails/senders",children:"Senders"}),g(o.NavItem,{NavLink:e,to:"/settings/emails/suppression-lists/unsubscribes",isActive:ge,children:"Suppression Lists"}),g(o.NavItem,{NavLink:e,to:"/settings/emails/sending-behavior",children:"Sending Behavior"})]}),M(o.NavAccordion,{text:"Integrations",icon:wi,isActive:x,children:[g(o.NavItem,{NavLink:e,to:p?"/integrations/connections":"/settings/integrations",children:"Connections"}),g(o.NavItem,{NavLink:e,to:"/integrations/webhooks",children:"Webhooks"}),g(o.NavItem,{NavLink:e,to:"/settings/keys",children:"API Keys"})]}),M(o.NavAccordion,{text:"Data",icon:Ai,isActive:w,children:[g(o.NavItem,{NavLink:e,to:"/settings/identifier",children:"Accounts & Users"}),g(o.NavItem,{NavLink:e,to:"/settings/events",children:"Events"}),g(o.NavItem,{NavLink:e,to:"/settings/properties/user",isActive:de,children:"Properties"})]}),m&&g(o.NavItem,{icon:Si,NavLink:e,to:"/settings/localization",children:"Localization"})]})})}),g(o.NavList,{children:g(et,{children:g(o.NavButton,{onClick:c,children:M(Ri,{fluid:!0,xAlign:"space-between",yAlign:"center",children:[g(Ei,{colorToken:"foreground-primary",children:"Sign out "}),g(Mi,{colorToken:"foreground-secondary",size:"small",icon:Pi})]})})})})]})};import Oi from"styled-components";var nt=Oi.div`
  flex: 0 0 220px;
  width: 220px;
  position: fixed;
  height: 100vh;
  background-color: var(--color-neutral-100);
  border-right: 1px solid var(--border-default);
  bottom: 0;
  left: 0;
  top: 0;
  z-index: 100;
`;import{jsx as Hi}from"react/jsx-runtime";var it=()=>Hi(nt,{});import{useCallback as zi,useEffect as Ui,useRef as Gi}from"react";import{createPopup as _i}from"@typeform/embed";var Vi={unmount:()=>{},open:()=>{}},Ki="QD5X3rU2";function at({size:e=60,formValues:t={}}){let i=Gi(Vi);return Ui(()=>{let r={size:e,hidden:t};i.current=_i(Ki,r)},[i,e,t]),{handleClick:zi(()=>i.current.open(),[i])}}import rt from"styled-components";import{Link as qi}from"@appcues/sonar";var st=rt.span`
  --font-size-regular: var(--font-size-small);
  --foreground-link: var(--color-blurple-400);
  --link-text-decoration: none;
`,lt=rt(qi)``;import{jsx as pt}from"react/jsx-runtime";var ct=({children:e,message:t,subject:i,user:n,mailto:r="support@appcues.com",...s})=>{let a=(n==null?void 0:n.fullName)||(n==null?void 0:n.fullname),{email:c}=n!=null?n:{},m=["Hi,",t,"Thanks!"].join(`

`),d={message:t,subject:i,text:m,mailto:r,...a&&{name:a},...c&&{email:c}},{handleClick:p}=at({formValues:d});return pt(st,{onClick:p,children:pt(lt,{"data-testid":"typeform-beacon",icon:!1,...s,children:e})})};import{Text as Qi}from"@appcues/sonar";import Xi from"styled-components";import{Link as mt}from"@appcues/sonar";import{Link as Yi}from"react-router-dom";import{jsx as gt}from"react/jsx-runtime";var Ji=({children:e,href:t,...i})=>t?gt(mt,{href:t,...i,children:e}):gt(mt,{forwardedAs:Yi,...i,children:e}),ce=Xi(Ji)``;import me from"styled-components";var Zi=me.div`
  align-items: center;
  background: white;
  box-shadow: var(--elevation-200);
  display: flex;
  height: 48px;
  justify-content: center;
`,pp=me.div`
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 9000;
  min-width: 870px;
`,dt=me(Zi)`
  background: var(--color-pink-600);
  color: white;
  gap: var(--spacing-small);
`,ut=me.div``;import{jsx as Re,jsxs as ft}from"react/jsx-runtime";var ji=()=>Re(ce,{colorToken:"white",href:"#",onClick:e=>{e.preventDefault()},children:"Stop spoofing"});function ea({accountId:e,spoofing:t,onDespoof:i}){return t?ft(dt,{"aria-live":"polite",role:"alert",children:[ft(Qi,{weight:"bold",colorToken:"white",children:["Spoofing Account ",e]}),Re(ut,{onClick:i,children:Re(ji,{})})]}):null}export{W as BannerIcon,ct as BeaconLink,it as BlankNavigation,ce as Link,Jo as MainNavigation,o as Navigation,tt as SettingsNavigation,ea as SpoofBanner,Ie as isTrialAccount};
//# sourceMappingURL=index.mjs.map